import { ShieldCheck, ExternalLink, Circle } from 'lucide-react';
import GlassBoxBadge from './GlassBoxBadge';

export function GlassBoxWidget({ transactions = [], title = "Glass Box \u2014 Live Verification" }) {
  const latest = transactions.slice(0, 5);

  return (
    <div className="rounded-2xl overflow-hidden" data-testid="glass-box-widget">
      <div className="bg-gradient-to-r from-[#7C3AED] to-[#2563EB] p-[1px] rounded-2xl">
        <div className="bg-white/90 backdrop-blur-xl rounded-2xl p-5">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-heading font-semibold text-sm text-[#111827]">{title}</h3>
            <div className="flex items-center gap-1.5">
              <Circle className="w-2 h-2 fill-[#10B981] text-[#10B981]" />
              <span className="text-xs text-[#10B981] font-medium font-body">Verified</span>
            </div>
          </div>
          {latest.length > 0 ? (
            <div className="space-y-3">
              {latest.map((tx, i) => (
                <div key={tx.id || i} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0">
                  <div className="flex-1 min-w-0">
                    <p className="text-xs text-gray-500 font-body">
                      {new Date(tx.timestamp).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                    </p>
                    <p className="text-sm font-medium text-[#111827] truncate font-body">
                      {tx.type === 'donation' ? 'Donation received' : tx.type === 'grant' ? 'Grant received' : 'Corporate match'}
                    </p>
                  </div>
                  <div className="text-right ml-3 shrink-0">
                    <p className="text-sm font-semibold text-[#111827] font-heading">${tx.amount?.toLocaleString()}</p>
                    <a
                      href={`https://bscscan.com/tx/${tx.txHash}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs text-[#7C3AED] hover:text-[#2563EB] font-mono transition-colors"
                      data-testid={`widget-tx-${i}`}
                    >
                      {tx.txHash?.slice(0, 8)}...
                    </a>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-400 text-center py-4 font-body">No transactions yet</p>
          )}
          <div className="mt-4 pt-3 border-t border-gray-100">
            <a
              href="https://humadashportal.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-1.5 text-xs text-gray-500 hover:text-[#7C3AED] transition-colors font-body"
              data-testid="widget-humadash-link"
            >
              View full transparency report on HumaDash
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GlassBoxWidget;
